import { Camera } from './camera.model';

export class NPC extends Camera {
    hasSensitivityConfig = true;
    hasVisionRecognitionConfig = true;

    minimumRebootFirmware = 0;
    minimumUnlockFirmware = 0;

}
